import usePreference from './usePreference';
import { accentPref } from '@/lib/accent';

// Reactive accessor for the accent-color preference.
// Returns [accent, setAccent]; re-renders all subscribers when accent changes.
export default function useAccent() {
  return usePreference(accentPref);
}
